import React from 'react';
import ReactDOM from 'react-dom'; 
import Header from '../Header/Header';
import Footer from '../Footer/Footer'; 
import axios from 'axios';
import _ from 'lodash';
import 'regenerator-runtime/runtime';
import ReactMarkdown from 'react-markdown'
import gfm from 'remark-gfm'


import './formulas.scss';

type Formula = {
    FormulaName :string
    FormulaShortDescription :string
    FormulaSyntax :string
    Arguments :FormulaArgument[]
    ExampleDescription :string
    ExampleSections :ExampleSection[]
    Notes :string
    RelatedFormulas :string
}

type FormulaNotFound = {
    FormulaName :string
}

type FormulaArgument = {
    Name :string
    Description :string
}

interface FormulaProps {
};

interface FormulaState {
    formulas: Formula[]
    page: string
    formulaDetail :Formula | null
    formulaNotFound :FormulaNotFound | null
    exampleResults: string[][]
}

type Example = {
	Input  :string
	Result :string
}

type ExampleSection = {
	Example      :Example
	ExampleRange :string[][]
	IsRange      :boolean
    rangeIndex: number
}


class FormulaHelp extends React.Component<FormulaProps, FormulaState> {
    constructor(props :FormulaProps) {
        super(props);

        const page = document.location.pathname.split('/').pop() || '';
        this.state = {
            formulas: [],
            page,
            formulaDetail: null,
            formulaNotFound: null,
            exampleResults: []
        }
    }


    async componentDidMount() {
        const res = await axios.get('/formulas.json');
        const formulas = _.sortBy(res.data, 'FormulaName') as Formula[];


        let formulaDetail :Formula | null = null;
        let formulaNotFound :FormulaNotFound | null = null;
        if(this.state.page !== 'formulas') {
            const formulasFound = formulas.filter(fml => fml.FormulaName === this.state.page.toUpperCase())

            if(formulasFound.length) {
                formulaDetail = formulasFound[0]
                let count = 1; 
                formulaDetail.ExampleSections.map((ex) => {
                    if(ex.IsRange){
                        ex.rangeIndex = count; 
                        count++; 
                    }
                    else{
                        ex.rangeIndex = 0

                        let tableResults :string[][]= []
                               
                        let r = ex.Example.Result
                        let a = r.replace(/\[|\] |\"/g, '').split('],')
                      
                        a.map(result => {
                            tableResults.push(result.replace("]]", "").split(','))
                        })

                        ex.ExampleRange = tableResults; 
                        ex.IsRange = true; 
                    }
                })


            } else {
                formulaNotFound = { FormulaName: this.state.page.toUpperCase() }
            }
        }
        this.setState({ formulas, formulaDetail, formulaNotFound });
    }
    
    render() {

        return <>
            <Header/>
                {this.state.page === 'formulas' && <div className="formulas content">
                <h1>Supported Formulas</h1>
    
                <table>
                    <tbody>
                    {this.state.formulas.map(fml => <tr key={fml.FormulaName}>
                        <td><a href={`/formulas/${fml.FormulaName.toLowerCase()}`}>{fml.FormulaName}</a></td>
                        <td>{fml.FormulaShortDescription}</td></tr>)}
                    </tbody>
                </table>
                </div>}

                {this.state.formulaNotFound && <>
                    <div className="content">
                        <h5 className="breadcrumbs"><a href="/formulas">FORMULAS</a> / <span>{this.state.formulaNotFound.FormulaName}</span></h5>
                    </div>
                <div className="formulas content">

                    <h1>{this.state.formulaNotFound.FormulaName}</h1>

                    <p>This formula has not been implemented yet. Check back soon!</p>
                </div>
                
                </>}
                {this.state.formulaDetail && <>
                    <div className="content">
                        <h5 className="breadcrumbs"><a href="/formulas">FORMULAS</a> / <span>{this.state.formulaDetail.FormulaName}</span></h5>
                    </div>
                <div className="formulas content">

                    <h1>{this.state.formulaDetail.FormulaName}</h1>

                    <p>{this.state.formulaDetail.FormulaShortDescription}</p>

                    <br />

                    <h2>Syntax</h2>

                    <h3 className="code">{`=${this.state.formulaDetail.FormulaSyntax}`}</h3>

                    {this.state.formulaDetail.Arguments.length > 0 && this.state.formulaDetail.Arguments[0].Description && <table className="parameters">
                        <tbody>
                            {this.state.formulaDetail.Arguments.map(arg => <tr key={arg.Name}><td><b>{arg.Name}</b></td> 
                            <td>{arg.Description}</td></tr>)}
                        </tbody>
                    </table>}

                    <div className="examples">
                        <ReactMarkdown remarkPlugins={[gfm]} children={`## Examples\n\n${this.state.formulaDetail.ExampleDescription}`} />

                        {
                        this.state.formulaDetail.ExampleSections.map((ex, i) => {
                            const alphabet = ["A", "B", "C", "D", "E", "F"]
                            if(ex.Example.Input) {
                                
                                return( <div  key={`ex_${i}`} className="small-table-container"> 
                                        <p className="code" >{`=${ex.Example.Input}`}</p>
                                         <table  className="sheet small-table">
                                            <tbody>
                                                {ex.ExampleRange.map((row, j) => {
                                                    return <tr key={`ex${i}_${j}`}>{row.map((cell, k) => 
                                                    <td key={`ex${i}_${j}_${k}`}>{cell}</td>)}</tr>
                                                })}
                                            </tbody>
                                        </table>
                                    </div>)
                            } else if(!ex.Example.Input && ex.ExampleRange.length) {
                                
                                return <div key={`ex_${i}`} >
                                        <h6> {`Example ${ex.rangeIndex}`}</h6>
                                            <table  className="sheet">
                                                <thead><tr><th className="header row-num">&nbsp;</th>{ex.ExampleRange[0].map((_, i) => <th key={`header_${i}`}
                                                className="header">{alphabet[i]}</th>)}</tr></thead>
                                                <tbody>
                                                    {ex.ExampleRange.map((row, j) => {
                                                        return <tr key={`ex${i}_${j}`}><td className="header">{j + 1}</td>{row.map((cell, k) => 
                                                        <td key={`ex${i}_${j}_${k}`}>{cell}</td>)}</tr>
                                                    })}
                                                </tbody>
                                            </table>
                                    </div>  
                            }
                        })
                        
                        }
                    </div>

                    <div className="notes">
                        <ReactMarkdown remarkPlugins={[gfm]} children={this.state.formulaDetail.Notes} />
                    </div>

                    <div className="related">
                        <ReactMarkdown remarkPlugins={[gfm]} children={this.state.formulaDetail.RelatedFormulas} />
                    </div>
                </div></>}
            <Footer/>
        </>
    }
}

ReactDOM.render(
    <FormulaHelp />, 
    document.getElementById('root')
); 